import { createSvgIcon } from '@mui/material';

const IconRetorno = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g id="Group_10687" data-name="Group 10687" transform="translate(-887 -2253)">
      <g id="Group_10189" data-name="Group 10189" transform="translate(192 -42)">
        <rect
          id="Rectangle_5275"
          data-name="Rectangle 5275"
          width="50"
          height="50"
          rx="25"
          transform="translate(695 2295)"
          fill="#f7f8f8"
        />
      </g>
      <g id="Group_6807" data-name="Group 6807" transform="translate(-228.013 -2540.984)">
        <g id="logo-99minutos.6ca31ef5" transform="translate(1118.856 4797.617)">
          <path
            id="Fill-14"
            d="M155.327,94.856l3.239-3.239s-2.09-5.329-9.612-9.717l-3.239,3.239,3.761,3.761-.836.836a19.639,19.639,0,0,0-32.389,15.045A19.643,19.643,0,1,0,150.835,91.93l.836-.836Zm-4.075,9.612A15.412,15.412,0,1,1,135.894,88.9a15.518,15.518,0,0,1,15.359,15.568Z"
            transform="translate(-116.251 -81.9)"
            fill="#9596ae"
          />
        </g>
        <path
          id="Path_3433"
          data-name="Path 3433"
          d="M275.382,34.431,270.154,29.2l5.228-5.228M270.154,29.2h14.377a5.228,5.228,0,1,1,0,10.456H263.872"
          transform="translate(858.217 4787.26)"
          fill="none"
          stroke="#9596ae"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </g>
  </svg>,

  'IconRetorno',
);

export default IconRetorno;
